export const ClientSegmentConstants = {
    ADMINISTRATOR: 'ADMINISTRATOR',
    APARTMENT: 'APARTMENT',
    EShop: 'EShop',
    Retailer: 'Retailer',
    Insurance: 'Insurance',
    FM: 'FM',
    Community: 'Community',
    RealEstate: 'RealEstate',
    Segment1: 'Segment1',
    Segment2: 'Segment2',
    Segment3: 'Segment3',
    UNDEFINED: 'UNDEFINED'
};
